import { useCallback, useEffect, useMemo, useState } from 'react'

interface SubscriptionAmountChangeHook {
  validate: () => boolean
  setAmount: (value: number) => void
  amount: number | undefined
  validationError: 'same_as_before' | 'invalid' | undefined
}
export function useDonationAmountValidation(value?: number, canBeEqualToInitialValue: boolean = false): SubscriptionAmountChangeHook {
  const [amount, setAmount] = useState<number | undefined>(value)
  const [validationError, setValidationError] = useState<'same_as_before' | 'invalid' | undefined>(undefined)
  const amountLimits = useMemo(() => {
    return { low: 50, high: undefined }
  }, [])

  const validate = useCallback(() => {
    if (!canBeEqualToInitialValue && amount === value) {
      setValidationError('same_as_before')
    } else if (amount === undefined || amount === 0 || isNaN(amount)) {
      setValidationError('invalid')
    } else if (amount < amountLimits.low || (amountLimits.high && amount > amountLimits.high)) {
      setValidationError('invalid')
    } else {
      setValidationError(undefined)
      return true
    }

    return false
  }, [amount])

  useEffect(() => {
    validate()
  }, [validate])

  return { validate, setAmount, amount, validationError }
}
